import { ResultStatus } from '@dispatch/shared/types';
import { ReactNode } from 'react';
import { DarkBox } from '../dark-box';
import { TopNavBarProps } from '../top-nav-bar/TopNavBar';
import { AppLayoutRenderHelper } from './AppLayoutRenderHelper';

export interface AppLayoutProps extends TopNavBarProps {
  children?: ReactNode;
  status?: ResultStatus;
  /** Re-invokes the bootstrap queries when the error state is shown. */
  onRetry?: () => void;
}

export function AppLayout(props: AppLayoutProps) {
  return (
    <div>
      <DarkBox sx={{ height: '100vh' }}>
        <AppLayoutRenderHelper {...props} />
      </DarkBox>
    </div>
  );
}

export default AppLayout;
